import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'app-turns-form-allowed-times-card',
  templateUrl: './turns-form-allowed-times-card.component.html',
  styleUrls: ['./turns-form-allowed-times-card.component.scss']
})
export class TurnsFormAllowedTimesCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() form: FormBasic;
  basicDataForm = new FormGroup({
    allowBefore: new FormControl(null, Validators.required),
    allowAfter: new FormControl(null, Validators.required)
  });
  updateFormAllowedTimesSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
              private snackbarService: SnackBarService) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  public submitForm() {
    this.updateFormAllowedTimesSubscription = this.formsTurnsService.updateFormAllowedTimes(this.form.InternalId, this.basicDataForm.get('allowAfter').value, this.basicDataForm.get('allowBefore').value).subscribe(
      (res) => {
        this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
        this.formsTurnsService.refreshForm();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      allowBefore: this.form.AllowBefore,
      allowAfter: this.form.AllowAfter
    });
  }

  ngOnDestroy() {
    if (this.updateFormAllowedTimesSubscription) { this.updateFormAllowedTimesSubscription.unsubscribe(); }
  }
}
